import Vue from 'vue'
import imageViewer from "vue-image-viewer";

Vue.use(imageViewer);